export const SYSTEM_PRODUCT_SELECT_PT_BR = {
	label: "Produto de sistema",
	placeholder: "Selecione o produto de sistema",
};

export type SystemProductSelectPtBr = typeof SYSTEM_PRODUCT_SELECT_PT_BR;
